<template>
  <div class="wallet-page" :class="{ 'loading': isProcessing }">
    <div class="breadcrumb-wrap">
      <h2>Organization Chart</h2>
      <ul class="breadcrumb">
        <li>
          <router-link :to="{name: 'Home'}"><i class="bx bxs-home"></i>Home</router-link>
        </li>
        <li>
          <router-link :to="{name: 'Dashboard'}"><i class="bx bxs-dashboard"></i>Dashboard</router-link>
        </li>
        <li>
          <span>Organization Chart</span>
        </li>
      </ul>
    </div>
    <div class="history-section">
      <div class="table-box">
        <div class="title">
          <h2>Sales Statistics</h2>
        </div>
        <div class="sales-statistics fields display-flex-start">
          <div class="field">
            <div class="field-input">
              <el-input placeholder="Enter User Aff Code" v-model="statForm.affCode" @keyup.enter.native="searchSaleStats"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="block">
              <el-date-picker
                v-model="statForm.fromTime"
                type="datetime"
                placeholder="From date"
                >
              </el-date-picker>
            </div>
          </div>
          <div class="field">
            <div class="block">
              <el-date-picker
                v-model="statForm.toTime"
                type="datetime"
                placeholder="To date"
                >
              </el-date-picker>
            </div>
          </div>
          <div class="field">
            <div class="field-label"></div>
            <div class="field-input field-submit">
              <button type="button" class="el-button el-button--default" :class="{ 'disabled': !isValidatedSearchForm }" @click="searchSaleStats"><span>Search</span></button>
            </div>
          </div>
        </div>
        <div class="total-sale">
          <h4>Total Sale Statistics</h4>
          <span class="number">{{ userStats }}</span>
        </div>
      </div>
    </div>

    <div class="history-section">
      <div class="table-box">
        <div class="title">
          <h2>Revenue By Line</h2>
        </div>
        <div class="table-fixed-wrap">
          <div class="table-box-inner">
            <dl class="table-medium">
              <dt>
                <div class="item-no">{{ $t('TEXT_NO') }}.</div>
                <div>{{ $t('TEXT_CODE') }}</div>
                <div class="width-1_5x">{{ $t('TEXT_USERNAME') }}</div>
                <div>Rank</div>
                <div>{{ $t('TEXT_TOTAL_SALE_DIRECT') }}</div>
                <!-- <div>{{ $t('TEXT_TOTAL_SALE_UNDIRECT') }}</div> -->
                <div>Total sale</div>
                <div class="w300px">Sortable</div>
              </dt>
              <template v-if="userStatSale.length">
                <dd v-for="(pack, index) in userStatSale" :key="pack.id" :class="{ 'brand': pack.branchOther }">
                  <div class="item-no">{{ index + 1 }}</div>
                  <div>{{ pack.code }}</div>
                  <div class="width-1_5x">{{ pack.username }}</div>
                  <div>{{ pack.role }}</div>
                  <div>{{ pack.totalSaleDirect }}</div>
                  <!-- <div>{{ pack.totalSaleUndirect }}</div> -->
                  <div>{{ pack.totalSale }}</div>
                  <div class="w300px display-flex-center" v-if="!pack.isExpired">
                    <flip-countdown :deadline="pack.timeExpiredStr" countdownSize="10px" labelSize="8px"></flip-countdown>
                    <el-button class="small" @click="change(pack.code)">Change</el-button>
                  </div>
                  <div class="w300px" v-else>
                  </div>
                </dd>
              </template>
              <template v-else>
                <dd class="no-data-wrap">
                  <div class="no-data">{{ $t('TEXT_NO_DATA') }}</div>
                </dd>
              </template>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <div class="history-section">
      <div class="table-box">
        <div class="title">
          <h2>Rank By Line</h2>
        </div>
        <div class="table-fixed-wrap">
          <div class="table-box-inner">
            <dl class="table-medium">
              <dt>
                <div class="item-no">{{ $t('TEXT_NO') }}.</div>
                <div>{{ $t('TEXT_CODE') }}</div>
                <div>{{ $t('TEXT_USERNAME') }}</div>
                <div>Current <br/>Rank</div>
                <template>
                  <div :class="index !== 0 ? 'item-no': ''" v-for="(level, index) in userStatRole.config" :key="`level${index}`" v-html="level === 0 ? 'Start' : `R${level}`"></div>
                </template>
              </dt>
              <template v-if="userStatRole.summary && userStatRole.summary.length">
                <dd v-for="(pack, index) in userStatRole.summary" :key="pack.id">
                  <div class="item-no">{{ index + 1 }}</div>
                  <div>{{ pack.code }}</div>
                  <div>{{ pack.username }}</div>
                  <div>{{ pack.role }}</div>
                  <template>
                    <div :class="index !== 0 ? 'item-no': ''" v-for="(level, index) in pack.statical" :key="`statical${index}`">{{ level }}</div>
                  </template>
                </dd>
              </template>
              <template v-else>
                <dd class="no-data-wrap">
                  <div class="no-data">{{ $t('TEXT_NO_DATA') }}</div>
                </dd>
              </template>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <div class="organization-box" id="change-matrix">
      <div class="title">
        <h2>Change Matrix</h2>
      </div>
      <div class="fields">
        <div class="field">
          <div class="field-label">User Code</div>
          <div class="field-input" style="display: flex">
            <el-input placeholder="Enter User Code" v-model="form.userCode" @keyup.enter.native="search"></el-input>
            <el-button @click="search" :class="{ 'disabled': !form.userCode }"><i class="el-icon-search"></i>Search</el-button>
          </div>
        </div>
        <div class="field">
          <div class="field-label">Username</div>
          <div class="field-input">
            <el-input v-model="currentUser.username" disabled></el-input>
          </div>
        </div>
        <div class="field">
          <div class="field-label">Role</div>
          <div class="field-input">
            <el-input v-model="currentUser.role" disabled></el-input>
          </div>
        </div>
        <div class="field">
          <div class="field-label">Referral Code</div>
          <div class="field-input">
            <el-input v-model="currentUser.refCode" disabled></el-input>
          </div>
        </div>
        <div class="field">
          <div class="field-label">Total Sale</div>
          <div class="field-input">
            <el-input v-model="currentUser.totalSale" disabled></el-input>
          </div>
        </div>
        <div class="field">
          <div class="field-label">Current Parent Code</div>
          <div class="field-input">
            <el-input v-model="currentUser.parentCode" disabled></el-input>
          </div>
        </div>
        <div class="field">
          <div class="field-label">New Parent Code</div>
          <div class="field-input">
            <el-input value="" v-model="form.parentCode"></el-input>
          </div>
        </div>
        <div class="field">
          <div class="field-label"></div>
          <div class="field-input field-submit">
            <button type="button" class="el-button el-button--default" :class="{ 'disabled': !isValidatedForm }" @click="showConfirm"><span>Change Matrix</span></button>
          </div>
        </div>
      </div>
    </div>
    <div :class="{ 'loading': isLoadingChart }">
      <binary-tree v-if="!simpleChart"/>
      <BinaryTreeByFolder v-else/>
    </div>
  </div>
</template>
<script>

import BinaryTree from '@/views/dashboard/components/BinaryTree'
// import BinaryTreeExpandable from '@/views/dashboard/components/BinaryTreeExpandable'
import CONSTANT from '@/configs/constant'
import FlipCountdown from 'vue2-flip-countdown'
// import FloatingButton from '../components/FloatButton.vue'
import BinaryTreeByFolder from '@/views/dashboard/components/BinaryTreeByFolder'
export default {
  components: {
    BinaryTree,
    // BinaryTreeExpandable,
    // FloatingButton,
    BinaryTreeByFolder,
    FlipCountdown
  },
  data () {
    return {
      statForm: {
        affCode: '',
        fromTime: '',
        toTime: ''
      },
      form: {
        userCode: '',
        parentCode: ''
      },
      currentUser: {},
      isLoadingData: false,
      isProcessing: false,
      colors: CONSTANT.COLORS_LEVEL
    }
  },
  computed: {
    isValidatedSearchForm () {
      return this.statForm.affCode && this.statForm.fromTime && this.statForm.toTime
    },
    isLoadingChart () {
      return this.$store.getters.isLoadingChart
    },
    isValidatedForm () {
      return this.currentUser.code && this.form.userCode && this.form.parentCode
    },
    isValidated () {
      return this.form.parentCode && this.form.userCode
    },
    levelColors () {
      return Object.keys(this.colors)
    },
    userStatRole () {
      return this.$store.getters.userStatRole
    },
    userStatSale () {
      return this.$store.getters.userStatSale
    },
    binaryData () {
      return this.$store.getters.binaryData
    },
    simpleChart () {
      return this.$store.getters.simpleChart
    },
    searchUserCode () {
      return this.$store.getters.searchUserCode
    },
    saleStatistics () {
      return this.$store.getters.saleStatistics
    },
    userStats () {
      return this.$store.getters.userStats
    }
  },
  watch: {
    searchUserCode (newCount, oldCount) {
      if (newCount !== oldCount && newCount) {
        document.getElementById('change-matrix').scrollIntoView()
        this.form.userCode = newCount
        this.search()
      }
    }
  },
  async created () {
    this.isProcessing = true
    await this.$store.dispatch('getUserStaticalSale')
    await this.$store.dispatch('getUserStaticalRole')
    this.isProcessing = false
  },
  mounted () {
    const code = this.$route.query.code
    this.$store.dispatch('getBinaryData', code)
  },
  methods: {
    convertDateToUTC (date) {
      return new Date(Date.UTC(date.getFullYear(), date.getMonth(),
        date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()))
    },
    searchSaleStats () {
      console.log(new Date(this.statForm.fromTime).getTime())
      const params = {
        affCode: this.statForm.affCode,
        fromTime: this.convertDateToUTC(new Date(this.statForm.fromTime)).getTime() / 1000,
        toTime: this.convertDateToUTC(new Date(this.statForm.toTime)).getTime() / 1000
      }
      this.$store.dispatch('getUserStats', params)
    },
    search () {
      if (!this.form.userCode) return
      const currentUser = this.binaryData.filter(temp => temp.code === parseInt(this.form.userCode))
      if (currentUser.length) {
        this.currentUser = currentUser[0]
      } else this.currentUser = {}
    },
    async changeMatrix () {
      if (!this.isValidatedForm) return
      this.isProcessing = true
      this.$store.dispatch('changeMatrix', this.form).then(rs => {
        console.log(rs)
        this.isProcessing = false
        rs.status && this.$store.dispatch('getBinaryData', this.$route.query.code)
      }).catch(err => {
        console.log(err)
        this.isProcessing = false
      })
    },
    showConfirm () {
      this.$confirm('Are you sure to change current matrix?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.changeMatrix()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Change canceled'
        })
      })
    },
    change (code) {
      this.$store.dispatch('setUserCode', code)
    }
  }
}
</script>
